import React from 'react'
import PropTypes from 'prop-types'
import { useEnvValue } from '@morningtrain/react-helpers'
import { useValue } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'

function AddModelValueToEnv (props) {
  const {
    path,
    name
  } = props

  const modelValue = useValue(name)

  const [envValue, setEnvValue] = useEnvValue(path, modelValue)

  React.useEffect(() => {
    setEnvValue(modelValue)
  }, [modelValue])

  return null
}

AddModelValueToEnv.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired
}

export default observer(AddModelValueToEnv)
